import { lazy } from "react";
import Loadable from "../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../constants/enums";
import {
  COMM_AUTO_DRIVER_ACTIVITY_TASK,
  COMM_AUTO_DRIVER_CLAIMS,
  COMM_AUTO_DRIVER_CONVICTION,
  COMM_AUTO_DRIVER_INFO,
  COMM_AUTO_DRIVER_INFORMATION,
  COMM_AUTO_DRIVER_ROOT,
} from "./Commerical.constants";

const CommAutoDriverRoot = Loadable(
  lazy(() =>
    import("./DriverRoot").then(({ CommAutoDriverRoot }) => ({
      default: CommAutoDriverRoot,
    }))
  )
);
const CommAutoDriverInformation = Loadable(
  lazy(() =>
    import(
      "./CommAutoDriver/CommAutoDriverInformation/CommAutoDriverInformationPage"
    ).then(({ CommAutomobileDriverInformationPage }) => ({
      default: CommAutomobileDriverInformationPage,
    }))
  )
);
const CommAutoDriverActivityTask = Loadable(
  lazy(() =>
    import("./CommAutoDriver/CommAutoDriverActivity/CommAutoDriver").then(
      ({ CommAutomobileActivityInformation }) => ({
        default: CommAutomobileActivityInformation,
      })
    )
  )
);
const CommAutoDriverClaims = Loadable(
  lazy(() =>
    import(
      "./CommAutoDriver/CommAutoDriverClaims/CommAutoDriverClaimsTab"
    ).then(({ CommAutomobileClaimTabs }) => ({
      default: CommAutomobileClaimTabs,
    }))
  )
);
const CommAutoDriverConviction = Loadable(
  lazy(() =>
    import(
      "./CommAutoDriver/CommAutoDriverConviction/CommAutoDriverConviction"
    ).then(({ CommAutomobileConvictionInformation }) => ({
      default: CommAutomobileConvictionInformation,
    }))
  )
);
export const DriverRootRoutes = [
  {
    path: `${COMM_AUTO_DRIVER_ROOT}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoDriverRoot />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${COMM_AUTO_DRIVER_INFO}/`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoDriverInformation />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${COMM_AUTO_DRIVER_INFORMATION}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoDriverInformation />
      </AuthorizedRoute>
    ),
  },

  {
    path: `${COMM_AUTO_DRIVER_INFORMATION}/:driverNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoDriverInformation />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${COMM_AUTO_DRIVER_ACTIVITY_TASK}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoDriverActivityTask />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${COMM_AUTO_DRIVER_ACTIVITY_TASK}/:taskNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoDriverActivityTask />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${COMM_AUTO_DRIVER_CLAIMS}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoDriverClaims />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${COMM_AUTO_DRIVER_CLAIMS}/:claimNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoDriverClaims />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${COMM_AUTO_DRIVER_CONVICTION}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoDriverConviction />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${COMM_AUTO_DRIVER_CONVICTION}/:driverNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoDriverConviction />
      </AuthorizedRoute>
    ),
  },
];
